import type { WsIncoming, WsOutgoing } from "./types";

export interface WsEnvelope<P = unknown> {
  v: 1;
  family: "control" | "live" | "internal";
  type: string;
  op: string;
  id?: string;
  payload?: P;
  deliveryClass?: "must_deliver" | "ordered" | "latest_only" | "droppable" | "bulk_resumable";
  dropPolicy?: "never" | "coalesce" | "drop_oldest" | "drop_newest" | "backpressure" | "close";
}

export function envelope<P>(
  family: WsEnvelope<P>["family"],
  type: string,
  op: string,
  payload?: P,
  extra: Omit<WsEnvelope<P>, "v" | "family" | "type" | "op" | "payload"> = {},
): WsEnvelope<P> {
  return { v: 1, family, type, op, payload, ...extra };
}

export function isEnvelope(value: unknown): value is WsEnvelope<Record<string, unknown>> {
  const m = value as Partial<WsEnvelope<Record<string, unknown>>> | null;
  return Boolean(
    m &&
    typeof m === "object" &&
    m.v === 1 &&
    typeof m.family === "string" &&
    typeof m.type === "string" &&
    typeof m.op === "string",
  );
}

export function isWsEnvelope(message: WsIncoming, family: string, type: string, op: string): boolean {
  return isEnvelope(message) && message.family === family && message.type === type && message.op === op;
}

export function asWsOutgoing<P>(message: WsEnvelope<P>): WsOutgoing {
  return message as unknown as WsOutgoing;
}
